import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ProductType } from '~/models/product/ProductType';
import { REMOTE_INSTALLATION_PRODUCT_KEY } from '~/store/campaign/byod.constants';
import { useBasket } from '../../campaign/useBasket';
import { MappedCampaign } from '../campaign.utils';
import { ProductGroupComponent } from '../components/ProductGroup';

export const SelectEquipmentProducts: React.FC = () => {
  const campaign = useOutletContext<MappedCampaign>();

  // Remote installation product only to be displayed for SMB3 and Streambox
  const hasOrderedReceiverSmb3OrStreambox = useBasket((s) =>
    s.selectedProducts.some((sp) => sp.productType === ProductType.Receiver && (sp.productKey === 'smb3' || sp.productKey === 'sb')),
  );
  const hasInternetProduct = useBasket((s) => s.hasInternetProduct)();
  const installationProducts = useMemo(() => {
    return hasOrderedReceiverSmb3OrStreambox
      ? campaign.products.installation
      : campaign.products.installation.map((bundle) => ({
          ...bundle,
          offers: bundle.offers.filter((offer) => offer.productKey !== REMOTE_INSTALLATION_PRODUCT_KEY),
        }));
  }, [hasOrderedReceiverSmb3OrStreambox, campaign.products.installation]);

  return (
    <>
      <ProductGroupComponent group={campaign.products.receiver} config={campaign.configs.receiver} type={ProductType.Receiver} />

      {!hasInternetProduct && installationProducts.length > 0 && (
        <ProductGroupComponent group={installationProducts} config={campaign.configs.installation} type={ProductType.Installation} />
      )}
      {/* Equipment (antennas) might be an empty list */}
      {!hasInternetProduct && campaign.products.equipment.length > 0 && (
        <ProductGroupComponent group={campaign.products.equipment} config={campaign.configs.equipment} type={ProductType.Equipment} />
      )}
    </>
  );
};
